import { FLAGS, useFlag } from '@iheartjane/feature-flags';
import { Box, Flex, Typography } from '@iheartjane/reefer';
import { Form, useFormContext } from '@iheartjane/reefer-hook-form';
import { useEffect, useMemo } from 'react';

import {
  VERIFICATION_TYPE_OPTIONS,
  useInitializeMedicalVerificationType,
} from '@jane/business-admin/components/shared/specials/modal/form';
import { useGlobalSpecialsModal } from '@jane/business-admin/providers/GlobalSpecialsModalProvider';
import type { SpecialTypeProps } from '@jane/business-admin/types';

import styles from './QualifiedGroup.module.css';

export const QualifiedGroup = ({
  name,
  options,
}: SpecialTypeProps['qualified_group']) => {
  const { getValues, watch, setValue } = useFormContext();
  const qualifiedGroupValue = getValues('ruleSettings.qualified_group');
  const qualifiedGroupWatch = watch('ruleSettings.qualified_group');
  const specialTypeWatch = watch('special_type');

  const { isDisabled } = useGlobalSpecialsModal();

  const medIdEnabled = useFlag(FLAGS.c3QualifiedGroupMedId);

  const qualifiedGroupType = useMemo(
    () => qualifiedGroupWatch?.type || qualifiedGroupValue?.type,
    [qualifiedGroupWatch?.type, qualifiedGroupValue?.type]
  );

  const isSenior = qualifiedGroupType === 'senior';
  const isMedical = !!medIdEnabled && qualifiedGroupType === 'medical';

  useEffect(() => {
    if (!qualifiedGroupType && specialTypeWatch === 'qualified_group') {
      setValue('ruleSettings.qualified_group.type', 'senior');
    }
  }, []);

  useInitializeMedicalVerificationType({
    enabled: !!medIdEnabled,
    name,
    qualifiedGroupType,
  });

  return (
    <Flex justifyContent="space-between" width="100%" gap={24}>
      <Flex width="100%" flexWrap="wrap" gap={24} mb={24}>
        <Form.SelectField
          width={isSenior || isMedical ? '100%' : '50%'}
          name={`${name}.type`}
          label="Qualified group"
          options={options || []}
          disabled={isDisabled}
        />
        {isMedical ? (
          <Box>
            <Typography variant="body-bold" mb={12}>
              Verification method
            </Typography>
            <Form.RadioFieldGroup
              name={`${name}.verification_type`}
              options={VERIFICATION_TYPE_OPTIONS}
              disabled={isDisabled}
              className={styles.verificationType}
            />
          </Box>
        ) : null}
        {isSenior ? (
          <Form.NumberField
            name={`${name}.required_age`}
            label="Age requirement"
            required
            width="100%"
            disabled={isDisabled}
            disableOnWheel
          />
        ) : null}
      </Flex>
    </Flex>
  );
};
